module.exports = __webpack_public_path__ + "static/media/pop_over_submit_icon.a714a3e2.svg";